// Global variables

// When any button with an aria-controls attribute that starts with 'filter-section-' is clicked
document.querySelectorAll("button[aria-controls^='filter-section-']").forEach((button) => {
	button.addEventListener("click", function () {
		const sectionId = this.getAttribute("aria-controls");
		document.querySelectorAll("." + sectionId).forEach((section) => {
			section.classList.toggle("hidden");
		});

		this.querySelectorAll("svg").forEach((svg) => {
			svg.classList.toggle("hidden");
		});

		const isExpanded = this.getAttribute("aria-expanded") === "true";
		this.setAttribute("aria-expanded", (!isExpanded).toString());
	});
});

function collapseAllSections() {
	document.querySelectorAll("button[aria-controls^='filter-section-']").forEach((button) => {
		const sectionId = button.getAttribute("aria-controls");
		document.querySelectorAll("." + sectionId).forEach((section) => {
			section.classList.add("hidden");
		});

		const plusIcon = button.querySelector("svg.plus-icon");
		const minusIcon = button.querySelector("svg.minus-icon");
		if (plusIcon) plusIcon.classList.remove("hidden");
		if (minusIcon) minusIcon.classList.add("hidden");

		button.setAttribute("aria-expanded", "false");
	});
}

document.addEventListener("click", function (event) {
	const targetSidebarMob = event.target.closest("#search-sidebar-mob");
	const targetSearchMob = event.target.closest("#search-mob");
	const closeButton = event.target.closest(".search-sidebar-close");

	if (targetSidebarMob) {
		//Toggle hidden from search-sidebar
		const sidebarElements = document.querySelectorAll(".filter-desktop");
		sidebarElements.forEach((sidebar) => {
			sidebar.classList.toggle("hidden");
		});
	}
});

document.querySelectorAll(".search-sidebar input[type='checkbox']").forEach((checkbox) => {
	checkbox.addEventListener("change", function () {
		const params = new URLSearchParams(window.location.search);
		const formValues = {};
		const engelValues = [];

		// Preserve existing important params if they exist
		const preserveParams = ["q", "order"];
		preserveParams.forEach((param) => {
			const value = params.get(param);
			if (value !== null) {
				params.set(param, value);
			}
		});

		// Clear previous topic[] and Engel params
		params.delete("topic[]");
		params.delete("engel");
		params.delete("engelLow");
		params.delete("engelHigh");
		params.delete("el");
		params.delete("em");

		document.querySelectorAll(".search-sidebar input[type='checkbox']:checked").forEach((checkedBox) => {
			let name = checkedBox.name;
			if (name.endsWith("[]")) {
				name = name.slice(0, -2);
			}
			if (name === "engel") {
				const [min, max] = checkedBox.value.split(",").map(Number);
				engelValues.push(min, max);
			} else {
				if (!formValues[name]) {
					formValues[name] = [];
				}
				formValues[name].push(checkedBox.value);
			}
		});

		if (engelValues.length) {
			const lowest = Math.min(...engelValues);
			const highest = Math.max(...engelValues);
			params.set("el", lowest);
			params.set("em", highest);
		} else {
			// If no Engel selected, ensure el and em are completely removed
			params.delete("el");
			params.delete("em");
		}

		for (const key in formValues) {
			formValues[key].forEach((value) => {
				params.append(`${key}[]`, value);
			});
		}
	});
});

document.addEventListener("DOMContentLoaded", function () {
	const gcFilterSearchForm = document.querySelector(".gc-search-form");

	if (gcFilterSearchForm) {
		gcFilterSearchForm.addEventListener("submit", function (event) {
			event.preventDefault(); // Prevent the default form submission

			// Get the current URL parameters
			const queryParameters = {};
			const queryString = location.search.substring(1);
			const re = /([^&=]+)=([^&]*)/g;
			let m;

			// Parse existing query parameters
			while ((m = re.exec(queryString))) {
				queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
			}

			// Get the value of the input field with name="q"
			const searchInput = gcFilterSearchForm.querySelector('input[name="q"]');
			if (searchInput && searchInput.value.trim() !== "") {
				queryParameters["q"] = searchInput.value.trim();
			} else {
				delete queryParameters["q"]; // Remove 'q' if the input is empty
			}

			// Construct the updated query string
			const url = document.location.href;
			const mainUrl = url.split("?")[0];
			const updatedQuery = new URLSearchParams(queryParameters).toString();

			// Reload the page with the updated URL
			window.location.href = mainUrl + (updatedQuery ? "?" + updatedQuery : "");
		});
	}
});

console.log("jQuery is loaded");
//if resources-slider exists
document.addEventListener("DOMContentLoaded", function () {
	console.log("DOM fully loaded and parsed");
	if ($(".resources-slider").length) {
		console.log("Resources slider exists");
		$(".resources-slider").on("init", function (event, slick, direction) {
			console.log("Resources slider initialized");
			AOS.refresh();
		});

		$(".resources-slider").slick({
			infinite: true,
			slidesToShow: 2,
			slidesToScroll: 2,
			nextArrow: '<button class="slick-arrow slick-next text-xl" aria-label="Next"><i class="far fa-arrow-right"></i></button>',
			prevArrow: '<button class="slick-arrow slick-prev text-xl" aria-label="Previous"><i class="far fa-arrow-left"></i></button>',
			autoplay: true,
			autoplaySpeed: 4000,
			dots: true,
			responsive: [
				{
					breakpoint: screen_xs,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	}
});
